<nav
    class="animate-header hidden lg:block top-header"
    [ngClass]="{
        scrolled: isScrolled,
    }">
    <div class="flex items-center justify-between">
        <div class="flex items-center gap-5 xl:gap-10 flex-1 min-w-0">
            <a class="flex-shrink-0" routerLink="/home">
                <img
                    alt="Brand logo"
                    class="block w-16 lg:w-[7.5rem] h-auto mr-3 lg:mr-6"
                    [src]="
                        isScrolled
                            ? '/assets/images/shared/brand-logo-2.png'
                            : '/assets/images/shared/brand-logo-white.png'
                    " />
            </a>

            @for (item of NAV_ITEMS; track item) {
                <div class="relative group">
                    <a class="product-dropdown-text" [routerLink]="item.route">
                        {{ item.label }}
                    </a>

                    @if (item.children?.length) {
                        <div class="absolute left-0 top-full pt-[22px] w-full"></div>

                        <div class="nav-dropdown">
                            @for (child of item.children; track child) {
                                <a
                                    class="nav-dropdown-text"
                                    [routerLink]="item.route"
                                    [queryParams]="{ categories: child.filter }">
                                    {{ child.label }}
                                </a>
                            }
                        </div>
                    }
                </div>
            }
        </div>

        <div class="flex items-center">
            @if (!showSearch) {
                <div class="search-icon" (click)="toggleSearch()">
                    @if (!isScrolled) {
                        <img src="/assets/images/shared/search.png" alt="search" />
                    } @else {
                        <img src="/assets/images/shared/search-black.png" alt="search" />
                    }
                </div>
            }

            @if (showSearch) {
                <div class="search">
                    @if (!isScrolled) {
                        <img
                            class="cursor-pointer"
                            src="/assets/images/shared/search.png"
                            alt="search"
                            (click)="closeSearch()" />
                    } @else {
                        <img
                            class="cursor-pointer"
                            src="/assets/images/shared/search-black.png"
                            alt="search"
                            (click)="closeSearch()" />
                    }
                    <input
                        class="search-input"
                        type="text"
                        [formControl]="searchControl"
                        [placeholder]="'Search Product' | translate"
                        (keyup.enter)="onSearch()" />
                </div>
            }

            <app-profile-dropdown [isScrolled]="isScrolled"></app-profile-dropdown>
        </div>
    </div>
</nav>

<nav class="top-header animate-header lg:hidden !bg-white">
    <div class="flex items-center justify-between">
        <div class="flex grow items-center gap-5 lg:gap-10">
            <a class="flex items-center" routerLink="/home">
                <img
                    src="/assets/images/shared/brand-logo-2.png"
                    alt="Brand logo"
                    class="block w-16 lg:w-[7.5rem] mr-3 lg:mr-6" />
            </a>
        </div>

        <app-profile-dropdown [isMobile]="true"></app-profile-dropdown>

        <div class="border border-solid rounded-lg px-2 pt-2 cursor-pointer ml-2">
            <mat-icon class="cursor-pointer text-primary icon-container" (click)="toggleSearchMenu()">
                <span class="icon menu" [class.active]="!menuToggle">menu</span>
                <span class="icon close" [class.active]="menuToggle">close</span>
            </mat-icon>
        </div>
    </div>

    @if (menuToggle) {
        @if (showSearch) {
            <div class="flex items-center gap-2 border border-solid rounded-lg p-2 mr-2 mt-3">
                <img
                    class="cursor-pointer"
                    src="/assets/images/shared/search-black.png"
                    alt="search"
                    (click)="toggleSearchMenu()" />
                <input
                    class="bg-transparent focus:outline-none focus:ring-0 w-full"
                    type="text"
                    [formControl]="searchControl"
                    [placeholder]="'Search Product' | translate"
                    (keyup.enter)="onSearch()" />
            </div>
        }
        @for (item of NAV_ITEMS; track item) {
            <div class="py-1 text-sm">
                <div class="flex items-center justify-between py-2">
                    <a class="flex items-center" [routerLink]="item.route">
                        {{ item.label }}
                    </a>

                    @if (item.children?.length) {
                        <mat-icon
                            class="cursor-pointer transition-transform duration-200"
                            [class.rotate-180]="openMenu === item.label"
                            (click)="toggleChild(item.label)">
                            expand_more
                        </mat-icon>
                    }
                </div>

                @if (item.children?.length && openMenu === item.label) {
                    <div class="flex flex-col gap-2">
                        @for (child of item.children; track child) {
                            <a
                                class="text-sm text-gray-600"
                                [routerLink]="item.route"
                                [queryParams]="{ categories: child.filter, applyOnMobile: true }">
                                {{ child.label }}
                            </a>
                        }
                    </div>
                }
            </div>
        }
    }
</nav>
